import { render, staticRenderFns } from "./AbaArquivosAposentadoria.vue?vue&type=template&id=9e0787f0"
import script from "./AbaArquivosAposentadoria.vue?vue&type=script&lang=ts"
export * from "./AbaArquivosAposentadoria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports